import React from 'react'

const V2RefreshStrip = () => (
    <div className="v2-refresh-strip" aria-hidden="true">
        <span />
    </div>
)

export default V2RefreshStrip
